import type { Route, Routes } from '@angular/router';
import { authGuard, authMatchGuard } from '@core/guards/auth.guard';

/** Default layout route with auth guards. */
export function protectedDefaultRoute(
  path: string,
  children: Routes,
  data?: Route['data'],
): Route {
  return {
    path,
    canMatch: [authMatchGuard],
    canActivate: [authGuard],
    data,
    loadComponent: () =>
      import('@layouts/default-layout/default-layout.component').then(
        (m) => m.DefaultLayoutComponent,
      ),
    children,
  };
}
